export default "__VITE_ASSET__QpFmWBC8__"